import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Console uses master-user auth only. Redirect to main app login;
 * after logging in as master user, AuthPage will send the user to /console.
 */
const ConsoleLogin = () => {
  return <Navigate to="/auth" replace />;
};

export default ConsoleLogin;
